import React from 'react'
import './nav.css'
import {AiOutlineHome, AiOutlineUser} from 'react-icons/ai'
import {BiBook, BiMessageSquareDetail} from 'react-icons/bi'
import { GrGallery } from "react-icons/gr";
import {RiServiceLine} from 'react-icons/ri'
import {useState} from 'react'
import { Tooltip } from 'react-tooltip'

export default function Nav() {
  const [activeNav, setActiveNav] = useState('#home')

  return (
    <nav>
      <a href="#home"  onClick={() => setActiveNav('#home')} className={activeNav === "#home" ? "active" : ""} data-tooltip-id="nav-tooltip" data-tooltip-content="Home"><AiOutlineHome /></a>
      <a href="#about" onClick={() => setActiveNav('#about')} className={activeNav === "#about" ? "active" : ""} data-tooltip-id="nav-tooltip" data-tooltip-content="About Me"><AiOutlineUser /></a>
      <a href="#experience" onClick={() => setActiveNav('#experience')} className={activeNav === "#experience" ? "active" : ""} data-tooltip-id="nav-tooltip" data-tooltip-content="My Experience"><BiBook /></a>
      <a href="#services" onClick={() => setActiveNav('#services')} className={activeNav === "#services" ? "active" : ""} data-tooltip-id="nav-tooltip" data-tooltip-content="Services"><RiServiceLine /></a>
      <a href="#portfolio" onClick={() => setActiveNav('#portfolio')} className={activeNav === "#portfolio" ? "active" : ""} data-tooltip-id="nav-tooltip" data-tooltip-content="Portflio"><GrGallery /></a>
      <a href="#contact" onClick={() => setActiveNav('#contact')} className={activeNav === "#contact" ? "active" : ""} data-tooltip-id="nav-tooltip" data-tooltip-content="Contact Me"><BiMessageSquareDetail /></a>
      <Tooltip id="nav-tooltip" />
    </nav>
  )
}
